import { fabric } from 'fabric';
import { deleteSvg, rotateSvg, scaleSvg } from '@/pages/customize/constant';

fabric.Object.prototype.borderColor = 'white';
fabric.Object.prototype.border = false;
fabric.Object.prototype.cornerStyle = 'circle';
fabric.Object.prototype.cornerColor = 'white';
fabric.Object.prototype.cornerSize = 8;
fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.cornerStrokeColor = 'gray';
fabric.Object.prototype.controls.mtr.visible = false;
fabric.Object.prototype.controls.ml.visible = false;
fabric.Object.prototype.controls.mr.visible = false;
fabric.Object.prototype.controls.mt.visible = false;
fabric.Object.prototype.controls.mb.visible = false;
fabric.Object.prototype.controls.tl.visible = false;
fabric.Object.prototype.controls.br.visible = false;

// 初始化控件
const rotateIcon = document.createElement('img');
const deleteIcon = document.createElement('img');
const scaleIcon = document.createElement('img');
rotateIcon.src = rotateSvg;
deleteIcon.src = deleteSvg;
scaleIcon.src = scaleSvg;

// @ts-ignore
const deleteObject = function (eventData, transform) {
  // console.warn(eventData, transform);
  const { target } = transform;
  const { canvas } = target;
  canvas.getActiveObjects().forEach((object: any) => {
    canvas.remove(object);
  });
};

function _renderIcon(icon: any) {
  return function renderIcon(ctx: any, left: any, top: any, styleOverride: any, fabricObject: any) {
    // @ts-ignore
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

fabric.Object.prototype.controls.deleteControl = new fabric.Control({
  x: -0.5,
  y: -0.5,
  cursorStyle: 'pointer',
  mouseUpHandler: deleteObject,
  render: _renderIcon(deleteIcon),
  cornerSize: 24
});
fabric.Object.prototype.controls.rotateControl = new fabric.Control({
  x: 0,
  y: 0.5,
  offsetY: 16,
  cursorStyle: 'pointer',
  actionHandler: fabric.controlsUtils.rotationWithSnapping,
  actionName: 'rotate',
  render: _renderIcon(rotateIcon),
  cornerSize: 24
});
fabric.Object.prototype.controls.scaleControl = new fabric.Control({
  x: 0.5,
  y: 0.5,
  cursorStyle: 'pointer',
  actionHandler: fabric.controlsUtils.scalingEqually,
  actionName: 'diy-scale',
  render: _renderIcon(scaleIcon),
  cornerSize: 24
});

fabric.Canvas.prototype.getItemsByName = function (name) {
  let objects = this.getObjects();
  for (var i = 0, len = this.size(); i < len; i++) {
    if (objects[i].name && objects[i].name === name) {
      return objects[i];
    }
  }
  return null;
};

export default fabric;
